import { render } from "./routerjadwalpsb.vue?vue&type=template&id=f5035154"
import script from "./routerjadwalpsb.vue?vue&type=script&lang=js"
export * from "./routerjadwalpsb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__